import { AccountAddress } from '../../../../shared/types/modules/account';
import { ISelect } from '../../../../shared/types/shared';

const joinParts = (parts: (string | undefined)[]) =>
    parts.filter(Boolean).join(' ');

export const buildOrbitAddress = (
    values: AccountAddress,
    cities: ISelect[],
    types1: ISelect[]
): string => {
    let address = '';

    if (values.type1) {
        const type1 = types1.find(
            (t) =>
                String(t.id) === String(values.type1) || t.name === values.type1
        );
        address = joinParts([
            type1?.name ||
                (typeof values.type1 === 'string' ? values.type1 : ''),
            values.type2,
            values.number1,
            values.letter1,
            values.letter2,
            values.quadrant1,
        ]);
    }

    if (values.number2) {
        address = address
            ? `${address} # ${values.number2}`
            : `# ${values.number2}`;

        const afterNumber2 = joinParts([
            values.letter3,
            values.letter4,
            values.quadrant2,
        ]);

        if (afterNumber2) {
            address = `${address} ${afterNumber2}`;
        }
    }

    const trailing: string[] = []; //Final text of the address

    const plate = joinParts([values.number3, values.quadrant3]);

    if (plate) trailing.push(plate);
    if (values.complement) trailing.push(values.complement);

    if (values.city) {
        const city = cities.find((c) => c.id === values.city);
        if (city?.name) trailing.push(city.name);
    }

    if (trailing.length > 0) {
        address = address
            ? `${address} - ${trailing.join(' - ')}`
            : trailing.join(' - ');
    }

    return address.trim();
};
